import React from 'react';
import { VStack, HStack, Slider, Text } from 'native-base';
export const CustomSlider = _ref => {
  let {
    value,
    maxLimit,
    handleChange
  } = _ref;
  return /*#__PURE__*/React.createElement(VStack, {
    width: '100%',
    space: 1
  }, /*#__PURE__*/React.createElement(HStack, null, /*#__PURE__*/React.createElement(Slider, {
    minValue: 0,
    accessibilityLabel: "withdrawal amount slider",
    onChange: handleChange,
    value: value,
    maxValue: maxLimit,
    "data-testID": "amount_slider",
    step: 1
  }, /*#__PURE__*/React.createElement(Slider.Track, {
    borderWidth: 6,
    borderColor: "primary.400",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement(Slider.FilledTrack, null)), /*#__PURE__*/React.createElement(Slider.Thumb, {
    size: 5,
    bg: "blue.950"
  }))), /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between",
    marginX: -2
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 'sm',
    fontWeight: 500
  }, "$0"), /*#__PURE__*/React.createElement(Text, {
    fontSize: 'sm',
    fontWeight: 500
  }, `$${Math.round(maxLimit / 1000)}K`)));
};
//# sourceMappingURL=index.js.map